import(/* webpackMode: "eager" */ "/vercel/path0/src/app/projects/academia-da-boa/page.tsx");
